import EventCheckoutModelBase from '../_generated/modelBases/event-checkout-model-base';

export default class EventCheckoutModel extends EventCheckoutModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
